// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message. 
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    CustomFieldExtraProps,
    CustomFieldExtraPropsFromJSON,
    CustomFieldExtraPropsToJSON,
    CustomFieldType,
    CustomFieldTypeFromJSON,
    CustomFieldTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface CustomFieldPayload
 */
export interface CustomFieldPayload {
    /**
     * 
     * @type {number}
     * @memberof CustomFieldPayload
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CustomFieldPayload
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CustomFieldPayload
     */
    entity: string;
    /**
     * 
     * @type {string}
     * @memberof CustomFieldPayload
     */
    label?: string;
    /**
     * 
     * @type {CustomFieldType}
     * @memberof CustomFieldPayload
     */
    type?: CustomFieldType;
    /**
     * NULL if default value not specified, Number type for dropdown field and date, string types for other
     * @type {string}
     * @memberof CustomFieldPayload
     */
    defaultValue?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CustomFieldPayload
     */
    isRequired?: boolean;
    /**
     * Should link with all projects?
     * @type {boolean}
     * @memberof CustomFieldPayload
     */
    addToAllProjects?: boolean;
    /**
     * Project IDs in array. Can only be specified if `add_to_all_projects` is false
     * @type {Array<number>}
     * @memberof CustomFieldPayload
     */
    projects?: Array<number>;
    /**
     * Weather to make this field searchable or not
     * @type {boolean}
     * @memberof CustomFieldPayload
     */
    search?: boolean;
    /**
     * 
     * @type {CustomFieldExtraProps}
     * @memberof CustomFieldPayload
     */
    extra?: CustomFieldExtraProps;
    /**
     * Company ID
     * @type {number}
     * @memberof CustomFieldPayload
     */
    company: number;
    /**
     * 
     * @type {string}
     * @memberof CustomFieldPayload
     */
    description?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CustomFieldPayload
     */
    isSortable?: boolean;
}

export function CustomFieldPayloadFromJSON(json: any): CustomFieldPayload {
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': json['name'],
        'entity': json['entity'],
        'label': !exists(json, 'label') ? undefined : json['label'],
        'type': !exists(json, 'type') ? undefined : CustomFieldTypeFromJSON(json['type']),
        'defaultValue': !exists(json, 'default_value') ? undefined : json['default_value'],
        'isRequired': !exists(json, 'is_required') ? undefined : json['is_required'],
        'addToAllProjects': !exists(json, 'add_to_all_projects') ? undefined : json['add_to_all_projects'],
        'projects': !exists(json, 'projects') ? undefined : json['projects'],
        'search': !exists(json, 'search') ? undefined : json['search'],
        'extra': !exists(json, 'extra') ? undefined : CustomFieldExtraPropsFromJSON(json['extra']),
        'company': json['company'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'isSortable': !exists(json, 'is_sortable') ? undefined : json['is_sortable'],
    };
}

export function CustomFieldPayloadToJSON(value?: CustomFieldPayload): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'id': value.id,
        'name': value.name,
        'entity': value.entity,
        'label': value.label,
        'type': CustomFieldTypeToJSON(value.type),
        'default_value': value.defaultValue,
        'is_required': value.isRequired,
        'add_to_all_projects': value.addToAllProjects,
        'projects': value.projects,
        'search': value.search,
        'extra': CustomFieldExtraPropsToJSON(value.extra),
        'company': value.company,
        'description': value.description,
        'is_sortable': value.isSortable,
    };
}


